import request from "@/util/http";
/**
 * 获取当前购物车
 */
export function get_current(params) {
	return request({
		url: '/order/shop/cart/get_current',
		method: 'get',
		params: params,
	})
}

/**
 * 添加
 */
export function add(params) {
	return request({
		url: '/order/shop/cart/add',
		method: 'post',
		params: params,
	})
}

/**
 * 列表
 */
export function list() {
	return request({
		url: '/order/shop/cart/list',
		method: 'get',
	})
}

/**
 * 修改
 */
export function modify(params) {
	return request({
		url: '/order/shop/cart/modify',
		method: 'post',
		params: params,
	})
}

/**
 * 选择
 */
export function select(params) {
	return request({
		url: '/order/shop/cart/select',
		method: 'post',
		params: params,
	})
}



/**
 * 移除
 */
export function remove(params) {
	return request({
		url: '/order/shop/cart/remove',
		method: 'delete',
		params: params,
	})
}

/**
 * 清空
 */
export function clear(data) {
	return request({
		url: '/order/shop/cart/clear',
		method: 'post',
		data: data,
	})
}



// module.exports = {
// 	get_current,
// 	add,
// 	list,
// 	modify,
// 	select,
// 	remove,
// 	clear,
// }
